// extracted by mini-css-extract-plugin
export default {"burger":"e7M3fqccDfSlj_HnAe06"};